<template>
    <div class="content-view transformData">
        <top-price code="unioncomputed"></top-price>
        <el-tabs v-model="activeName" @tab-click="handleClick">
            <el-tab-pane
                v-for="(item, index) in tabs"
                :key="index"
                :label="item.name"
                :name="item.name"
            >
                <div v-if="item.name == '指数组合计算'">
                    <el-row>
                        <el-col :span="6">
                            <div class="title fs-20 fc-333 flex flex-between">
                                <div>
                                    <img :src="require('../assets/img/trans.png')" />
                                    {{item.name}}
                                </div>
                                <div>
                                    <a
                                        href="javascript:;"
                                        @click="groupClear"
                                        class="fc-theme fs-14"
                                        type="text"
                                    >清空输入框</a>
                                </div>
                            </div>
                            <el-card class="box-card marginT-10">
                                <el-form ref="form" :model="form" label-width="90px">
                                    <el-form-item
                                        v-for="(item, index) in calGroup.form"
                                        :key="index"
                                        :label="calGroup.cn[index]"
                                    >
                                        <el-input v-model="calGroup.form[index]" size="small"></el-input>
                                    </el-form-item>
                                </el-form>
                            </el-card>
                        </el-col>
                        <el-col :span="5">
                            <div class="center-btn text-center">
                                <el-button @click="transDataadvance" type="danger">立即计算</el-button>
                                <div class="btn-tip">
                                    <div>请输入全部数据，否则</div>
                                    <div>高阶指标将无法计算</div>
                                </div>
                                <div class="btn-tip marginT-10">
                                    <div>发布任务，调控各个指数</div>
                                    <div>
                                        <el-button
                                            @click="pushUrl('/flow/taobao')"
                                            class="marginT-10"
                                            type="danger"
                                            plain
                                        >控制支付转换率</el-button>
                                    </div>
                                </div>
                            </div>
                        </el-col>
                        <el-col :span="6">
                            <div class="title fs-20 fc-333 flex flex-between">
                                <div>
                                    <img :src="require('../assets/img/transresult.png')" />
                                    实际值
                                </div>
                            </div>
                            <el-card class="box-card marginT-10">
                                <el-form ref="form" :model="form" label-width="90px">
                                    <el-form-item
                                        v-for="(item, index) in calGroup.result"
                                        :key="index"
                                        :label="calGroup.cn[index]"
                                    >
                                        <el-input
                                            v-model="calGroup.result[index]"
                                            :readonly="true"
                                            size="small"
                                        ></el-input>
                                    </el-form-item>
                                </el-form>
                            </el-card>
                        </el-col>
                        <el-col :span="1">
                            <div>&nbsp;</div>
                        </el-col>
                        <el-col :span="6">
                            <div class="title fs-20 fc-333 flex flex-between">
                                <div>
                                    <img :src="require('../assets/img/advance.png')" />
                                    高阶指标
                                </div>
                            </div>
                            <el-card class="box-card marginT-10">
                                <el-form ref="form" :model="form" label-width="90px">
                                    <el-form-item
                                        v-for="(item, index) in calGroup.highOrder"
                                        :key="index"
                                        :label="calGroup.cn[index]"
                                    >
                                        <el-input
                                            v-model="calGroup.highOrder[index]"
                                            :readonly="true"
                                            size="small"
                                        ></el-input>
                                    </el-form-item>
                                </el-form>
                            </el-card>
                        </el-col>
                    </el-row>
                    <div>
                        <p class="top-tip fc-333 fs-14 noborder">
                            <i class="el-icon-s-opportunity"></i>
                            <span>温馨提示：组合指数计算工具可以多指标同时换算，并同步组合计算出日常运营所需要的相应高阶指标参考数值，计算结果准确率达99.99%。如需验证数据准确性帮助，可加微信好友联系指导验证操作！</span>
                        </p>
                    </div>
                </div>
                <div v-else>
                    <el-row>
                        <el-col :span="8">
                            <div class="title fs-20 fc-333 flex flex-between">
                                <div>
                                    <img :src="require('../assets/img/trans.png')" />
                                    {{item.name}}
                                </div>
                                <div>
                                    <a
                                        href="javascript:;"
                                        @click="form.exponent = undefind"
                                        class="fc-theme fs-14"
                                        type="text"
                                    >清空输入框</a>
                                </div>
                            </div>
                            <div
                                class="desc fc-666 fs-12"
                            >请输入要计算的{{item.name}}，一行一个（支持从excel复制粘贴），单次最大支持5000个指数同时批量计算！</div>
                            <el-input
                                type="textarea"
                                :placeholder="'请在这里输入' + item.name"
                                v-model="form.exponent"
                                resize="false"
                                :rows="25"
                            ></el-input>
                            <div
                                class="input-tip text-center fs-12 fc-666 marginT-10"
                            >共输入{{form.exponent ? form.exponent.split('\n').filter(x => x).length : 0 }}个指数值</div>
                        </el-col>
                        <el-col :span="6">
                            <div class="center-btn text-center">
                                <el-button @click="transData(item)" type="danger">转换成{{item.tip}}</el-button>
                                <div
                                    v-if="(item.name == '交易指数' || item.name == '客群指数') && configData.is_proxy_site == 0"
                                    class="btn-tip"
                                >
                                    <div>v兔阿紫(工具使用指导)</div>
                                    <img :src="require('../assets/img/service_wechat.jpg')" alt />
                                    <div>如需帮助，微信扫一扫，加我为好友</div>
                                </div>
                                <div
                                    v-if="(item.name == '交易指数' || item.name == '客群指数') && configData.is_proxy_site != 0 && configData.proxy_info && configData.proxy_info.site_qrcode"
                                    class="btn-tip"
                                >
                                    <div>客服(工具使用指导)</div>
                                    <img
                                        :src="'http://' + configData.static_url + '/' + configData.proxy_info.site_qrcode"
                                    />
                                    <div>如需帮助，微信扫一扫，加我为好友</div>
                                </div>
                                <div v-if="item.name == '流量指数'" class="btn-tip marginT-10">
                                    <div>发布任务，鱼塘里的粉丝</div>
                                    <div>按照指定词搜索浏览</div>
                                    <div>
                                        <el-button
                                            @click="pushUrl('/flow/taobao')"
                                            class="marginT-10"
                                            type="danger"
                                            plain
                                        >提升访客数</el-button>
                                    </div>
                                </div>
                                <div v-if="item.name == '支付转化指数'" class="btn-tip marginT-10">
                                    <div>发布任务，通过访客数来控制</div>
                                    <div>支付转化率在合理范围内</div>
                                    <div>
                                        <el-button
                                            @click="pushUrl('/flow/taobao')"
                                            class="marginT-10"
                                            type="danger"
                                            plain
                                        >控制支付转化率</el-button>
                                    </div>
                                </div>
                                <div v-if="item.name == '搜索/点击人气'" class="btn-tip marginT-10">
                                    <div>发布任务，通过访客数来</div>
                                    <div>控制转化率</div>
                                    <div>
                                        <el-button
                                            @click="pushUrl('/flow/taobao')"
                                            class="marginT-10"
                                            type="danger"
                                            plain
                                        >控制搜索/点击人气</el-button>
                                    </div>
                                </div>
                                <div v-if="item.name == '收藏人气'" class="btn-tip marginT-10">
                                    <div>发布任务，提高收藏人数</div>
                                    <div>
                                        <el-button
                                            @click="pushUrl('/flow/taobao')"
                                            class="marginT-10"
                                            type="danger"
                                            plain
                                        >提高收藏人数</el-button>
                                    </div>
                                </div>
                                <div v-if="item.name == '加购指数/人气'" class="btn-tip marginT-10">
                                    <div>发布任务，提高收藏人数</div>
                                    <div>
                                        <el-button
                                            @click="pushUrl('/flow/taobao')"
                                            class="marginT-10"
                                            type="danger"
                                            plain
                                        >提高加购人数</el-button>
                                    </div>
                                </div>
                            </div>
                        </el-col>
                        <el-col :span="8">
                            <div class="title fs-20 fc-333 flex flex-between">
                                <div>
                                    <img :src="require('../assets/img/transresult.png')" />
                                    {{item.tip}}
                                </div>
                                <div>
                                    <a
                                        href="javascript:;"
                                        class="fc-theme fs-14"
                                        type="text"
                                        @click="copy"
                                        ref="copy"
                                    >复制结果</a>
                                </div>
                            </div>
                            <div
                                class="desc fc-666 fs-12"
                            >转换成{{item.tip}}的计算结果，可以直接复制粘贴到excel使用，误差0.01%左右。如果需使用指导或验证帮助可联系微信！</div>
                            <el-input
                                type="textarea"
                                id="success_form_input"
                                v-model="formResult"
                                resize="false"
                                :readonly="true"
                                :rows="25"
                            ></el-input>
                        </el-col>
                    </el-row>
                    <p class="top-tip fc-333 fs-14 noborder">
                        <i class="el-icon-s-opportunity"></i>
                        <span>温馨提示：{{item.name}}计算结果 = {{item.tip}}，准确率达99.99%。如需验证数据准确性帮助，可加微信好友联系指导验证操作！</span>
                    </p>
                    <div v-if="item.name == '交易指数'" class="marginT-20">
                        <div>【交易指数】计算结果快速验证方法</div>
                        <div>
                            <img src="https://pic.rmb.bdstatic.com/bjh/b4555d2388607522e4aad5671bb83470.png" />
                        </div>
                    </div>
                </div>
            </el-tab-pane>
        </el-tabs>
    </div>
</template>

<script>
import Clipboard from 'clipboard'
import appConfig from '../mixin/appConfig'
export default {
    mixins: [appConfig],
    data() {
        return {
            activeName: '指数组合计算',
            tabs: [

                {
                    name: '指数组合计算',
                    tip: '高阶计算'
                },
                {
                    name: '交易指数',
                    tip: '交易金额',
                    type: 1
                },
                {
                    name: '流量指数',
                    tip: '访客数',
                    type: 2
                },
                {
                    name: '支付转化指数',
                    tip: '支付转化率',
                    type: 7
                },
                {
                    name: '客群指数',
                    tip: '支付买家数',
                    type: 3
                },
                {
                    name: '搜索/点击人气',
                    tip: '搜索/点击人数',
                    type: 6
                },
                {
                    name: '收藏人气',
                    tip: '收藏人数',
                    type: 4
                },
                {
                    name: '加购指数/人气',
                    tip: '加购人数',
                    type: 5
                }
            ],
            calGroup: {
                form: {
                    trade_index: undefined, // 交易
                    traffic_index: undefined, //流量
                    payment_index: undefined, //转化
                    customer_group_index: undefined, //客群
                    colletct_index: undefined, //收藏
                    cart_index: undefined, //加购
                    search_index: undefined, //搜索
                    click_index: undefined //点击
                },
                cn: {
                    trade_index: '交易指数',
                    traffic_index: '流量指数',
                    payment_index: '转化率指数',
                    customer_group_index: '客群指数',
                    colletct_index: '收藏人气',
                    cart_index: '加购人气',
                    search_index: '搜索人气',
                    click_index: '点击人气',

                    trade_num: '交易金额',
                    traffic_num: '访 客 数',
                    payment_point: '支付转化率',
                    customer_group_num: '买 家 数',
                    colletct_num: '收藏人数',
                    cart_num: '加购人数',
                    search_num: '搜索人数',
                    click_num: '点击人数',

                    advance_uv_value: 'uv价值',
                    advance_unit_price: '客单价',
                    advance_search_point: '搜索占比',
                    advance_collect_point: '收藏率',
                    advance_cart_point: '加购率'
                },
                result: {
                    trade_num: undefined, //'交易金额'
                    traffic_num: undefined, //'访客数'
                    payment_point: undefined, //'支付转化率'
                    customer_group_num: undefined, //'买家数'
                    colletct_num: undefined, //'收藏人数'
                    cart_num: undefined, //'加购人数'
                    search_num: undefined, //'搜索人数'
                    click_num: undefined //'点击人数'
                },
                highOrder: {
                    advance_uv_value: undefined, //uv价值
                    advance_unit_price: undefined, //客单价
                    advance_search_point: undefined, //搜索占比
                    advance_collect_point: undefined, //收藏率
                    advance_cart_point: undefined //加购率
                }
            },
            form: {
                exponent: undefined
            },
            formResult: undefined
        }
    },
    methods: {
        handleClick() {
            this.form.exponent = undefined
            this.formResult = undefined
        },
        pushUrl(url) {
            if (!localStorage.token) {
                // this.$store.dispatch('openLoginModal')
                this.$bus.emit('openLogin')
            } else {
                this.$router.push(url)
            }
        },
        async transData(item) {
            if (!localStorage.token) {
                // this.$store.dispatch('openLoginModal')
                this.$bus.emit('openLogin')
                return
            }
            window.checkDiscountPackage("unioncomputed")
            const input = this.form.exponent.split('\n').filter(x => x)
            if (input.length == 0) {
                this.$message.error(`请输入${item.name}`)
                return
            }
            const data = await this.$fetch(
                '/api/proxy/web/unioncomputed',
                {
                    type: item.type,
                    item: input.join(',')
                },
                'post'
            )
            if (data.code == 0 && data.data.length > 0) {
                this.formResult = data.data.join('\n')
            } else {
                this.formResult = undefined
            }
        },
        async transDataadvance() {
            window.checkDiscountPackage("unioncomputed")
            const input = this.calGroup.form
            const data = await this.$fetch('/api/proxy/web/unioncomputed', { ...input }, 'post')
            if (data.code == 0) {
                this.calGroup.result = data.data.nomarl_target
                this.calGroup.highOrder = data.data.advance_target
            }
        },
        groupClear() {
            for (const key in this.calGroup.form) {
                this.$set(this.calGroup.form, key, undefined)
            }
            for (const key in this.calGroup.result) {
                this.$set(this.calGroup.result, key, undefined)
            }
            for (const key in this.calGroup.highOrder) {
                this.$set(this.calGroup.highOrder, key, undefined)
            }
        },
        copy() {
            if (!this.formResult) {
                this.$message.error('无结果')
                return
            }
            this.$copyText(this.formResult).then(
                () => {
                    this.$message.success('复制成功')
                },
                () => {
                    this.$message.error('复制失败了')
                }
            )
        }
    },
    mounted() {}
}
</script>

<style lang="scss" scoped>
.transformData {
    .center-btn {
        margin-top: 200px;
    }

    .btn-tip {
        font-size: 12px;
        color: #666;
        padding-top: 20px;
        padding-bottom: 20px;
        text-align: center;
        img {
            width: 200px;
        }
    }

    .title {
        margin-top: 10px;
        img {
            height: 30px;
            position: relative;
            top: -1px;
        }
    }
    .desc {
        margin: 10px 0;
    }
}
</style>
<style lang="scss">
.transformData {
    .el-card__body {
        padding-left: 5px;
        padding-right: 20px;
    }
}
</style>
